module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_PT-a853a5463825153e86e756e97e7595b5.svg";